import AccountLayout from '@/layouts/AccountLayout.tsx';

const Delete = () => (
  <AccountLayout title="Delete Account">You are about to delete your account here</AccountLayout>
);

export default Delete;
